import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=7480b281&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"
import style0 from "./footer.vue?vue&type=style&index=0&id=7480b281&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7480b281",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/product/interview/footer.vue
// module id = null
// module chunks = 